<template>
  <div class="about_invite">
    <ul class="cont_list">
      <li v-for="(item,index) in list" :key="index">
        <router-link
         :to="'/content?id='+item.id" 
         class="clearfloat" 
         :class="{'newslist_new':dayjs(item.updateTime).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')}"
        >
          <div class="fr">{{dayjs(item.updateTime).format('YYYY-MM-DD')}}</div>
          <div class="inner single-line">{{item.title}}</div>
        </router-link>
      </li>
    </ul>

    <div class="cont_list_pag">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :current-page="currentPage"
        @current-change = "currentPag">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'policyLocal',
  data(){
    return{
      total: 25,
      currentPage: 1,
      id: '12',
      list: []
    }
  },
  mounted: function(){
    var _this = this

    if(_this.$router.history.current.query.id){
      _this.id = _this.$router.history.current.query.id
    }
    _this.getDetail(_this.id, _this.currentPage)
  },
  methods: {
    currentPag(index){
      var _this = this
      _this.getDetail(_this.id, index)
    },
    async getDetail(id,index){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/getNewsList',{page: index, classification: id});
      if(data.code == 200){
        _this.list = data.data.list
        _this.total = data.data.total
      }
    }
  },
}
</script>